import { GetContactActivitiesDocument, useLogActivityMutation } from "generated/graphql";

type UseLogActivityArgs = {
  contactId?: string | null;
  opportunityId?: string | null;
  first?: number;
  page?: number;
  shouldRefetch?: boolean;
};

export const useLogActivity = ({
  contactId,
  opportunityId,
  first = 50,
  page = 1,
  shouldRefetch = false,
}: UseLogActivityArgs) => {
  const refetchQueries =
    shouldRefetch && contactId
      ? [
          {
            query: GetContactActivitiesDocument,
            variables: {
              contactId,
              opportunityId: opportunityId ?? undefined,
              first,
              page,
            },
          },
        ]
      : [];

  const [mutation, result] = useLogActivityMutation({
    refetchQueries,
  });

  return [mutation, result] as const;
};
